import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

let firebaseConfig = {};

console.log(process.env.REACT_APP_TARGET_ENV);

if (process.env.REACT_APP_TARGET_ENV === 'local') {
  firebaseConfig = {
    apiKey: 'AIzaSyClsAtMF6rHhoNWgYfBigX35fcIs0Zojwg',
    authDomain: 'app-dev-381401.firebaseapp.com',
    projectId: 'app-dev-381401',
    storageBucket: 'app-dev-381401.appspot.com',
    messagingSenderId: '1090205382087',
    appId: '1:1090205382087:web:a0a74e4cf2c15073b515e2',
  };
}

if (process.env.REACT_APP_TARGET_ENV === 'development') {
  firebaseConfig = {
    apiKey: 'AIzaSyClsAtMF6rHhoNWgYfBigX35fcIs0Zojwg',
    authDomain: 'app-dev-381401.firebaseapp.com',
    projectId: 'app-dev-381401',
    storageBucket: 'app-dev-381401.appspot.com',
    messagingSenderId: '1090205382087',
    appId: '1:1090205382087:web:a0a74e4cf2c15073b515e2',
  };
}

// Simulation shares the dev Firebase project until it gets its own.
if (process.env.REACT_APP_TARGET_ENV === 'simulation') {
  firebaseConfig = {
    apiKey: 'AIzaSyClsAtMF6rHhoNWgYfBigX35fcIs0Zojwg',
    authDomain: 'app-dev-381401.firebaseapp.com',
    projectId: 'app-dev-381401',
    storageBucket: 'app-dev-381401.appspot.com',
    messagingSenderId: '1090205382087',
    appId: '1:1090205382087:web:a0a74e4cf2c15073b515e2',
  };
}

if (process.env.REACT_APP_TARGET_ENV === 'production') {
  firebaseConfig = {
    apiKey: 'AIzaSyDmiC0R8jEqkIQnn83iqEm-Av3TirPCBr4',
    authDomain: 'app-prod-383715.firebaseapp.com',
    projectId: 'app-prod-383715',
    storageBucket: 'app-prod-383715.appspot.com',
    messagingSenderId: '14575999557',
    appId: '1:14575999557:web:62787b4c543335f399212c',
    measurementId: 'G-WDEYED32JP',
  };
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Auth emulator: the hosted one for simulation, localhost for dev servers.
// REACT_APP_FIREBASE_AUTH_EMULATOR_URL overrides the URL in either case.
let defaultEmulatorUrl = null;
if (process.env.REACT_APP_TARGET_ENV === 'simulation') {
  defaultEmulatorUrl = 'https://firebase.vibecloser.com/';
} else if (process.env.NODE_ENV === 'development') {
  defaultEmulatorUrl = 'http://localhost:9099';
}

if (defaultEmulatorUrl) {
  connectAuthEmulator(
    auth,
    process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_URL || defaultEmulatorUrl,
  );
}

export default app;
